export default "__VITE_ASSET__CS0iuyKB__"